"use strict";
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 渲染引擎
 */
var Engine = /** @class */ (function () {
    function Engine(ctx, viewPort) {
        this.ctx = ctx;
        this.viewPort = viewPort;
        /**
         * 图形池
         */
        this.shapePool = [];
    }
    Engine.prototype.getShape = function (zindex) {
        var shape = this.shapePool.find(function (item) { return item.zindex === zindex; });
        if (shape === undefined) {
            throw new Error("cont found shape by zindex:" + zindex);
        }
        return shape;
    };
    Object.defineProperty(Engine.prototype, "shapePoolSize", {
        get: function () {
            return this.shapePool.length;
        },
        enumerable: true,
        configurable: true
    });
    Engine.prototype.add = function (shape) {
        this.shapePool.push(shape);
        shape.setEngine(this);
    };
    Engine.prototype.addSome = function (shapes) {
        var _this = this;
        shapes.forEach(function (shape) { return _this.add(shape); });
    };
    Engine.prototype.remove = function (shape) {
        var f = this.shapePool.findIndex(function (s) { return s === shape; });
        if (f !== -1) {
            this.shapePool.splice(f, 1);
        }
    };
    Engine.prototype.removeSome = function (shapes) {
        var _this = this;
        shapes.forEach(function (shape) { return _this.remove(shape); });
    };
    Engine.prototype.render = function (isClear) {
        var _this = this;
        if (isClear) {
            this.clearAll();
        }
        this.shapePool.forEach(function (item) {
            if (item.visable) {
                item.renderAfterState(_this.ctx);
            }
        });
    };
    Engine.prototype.clearAll = function () {
        this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
    };
    /**
     * 触发视窗鼠标事件
     * @param vev 视窗鼠标事件
     */
    Engine.prototype.trigger = function (vev) {
        var e_1, _a;
        var point = vev.p, action = vev.action;
        try {
            for (var _b = __values(this.shapePool), _c = _b.next(); !_c.done; _c = _b.next()) {
                var shape = _c.value;
                if (shape.inRegionAndSetEnterState(point)) {
                    if (action === 'down') {
                        if (shape.onMouseDown(vev))
                            continue;
                        else
                            return;
                    }
                    else if (action === 'enter') {
                        if (shape.onMouseEnter(vev))
                            continue;
                        else
                            return;
                    }
                    else if (action === 'leave') {
                        if (shape.onMouseLeave(vev))
                            continue;
                        else
                            return;
                    }
                    else if (action === 'move') {
                        if (shape.isEnter) {
                            vev.action = 'enter';
                            shape.onMouseEnter(vev);
                        }
                        else if (shape.isLeave) {
                            vev.action = 'leave';
                            shape.onMouseEnter(vev);
                        }
                        else if (shape.onMouseMove(vev))
                            continue;
                        else
                            return;
                    }
                    else if (action === 'out') {
                        if (shape.onMouseOut(vev))
                            continue;
                        else
                            return;
                    }
                    else if (action === 'over') {
                        if (shape.onMouseOver(vev))
                            continue;
                        else
                            return;
                    }
                    else if (action === 'up') {
                        if (shape.onMouseUp(vev))
                            continue;
                        else
                            return;
                    }
                    else if (action === 'wheel') {
                        if (shape.onMouseWheel(vev))
                            continue;
                        else
                            return;
                    }
                    else {
                        throw new Error("cont handler the mouse event " + vev.action);
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    Engine.prototype.hitTest = function (p) {
        return this.shapePool
            .map(function (shape) { return [shape.inRegion(p), shape]; })
            .filter(function (item) { return item[0]; })
            .map(function (item) { return item[1].zindex; });
    };
    Engine.prototype.removeSelected = function () {
        this.shapePool.filter(function (shape) { return shape.isSelected(); }).forEach(function (shape) { return shape.remove(); });
    };
    return Engine;
}());
exports.Engine = Engine;
//# sourceMappingURL=Engine.js.map